export default {
  'menu.CompanyServiceListPage': '意见反馈列表',
}